/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { FC, useState, useEffect, useContext, ReactElement } from 'react';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import { storeScrollPosition } from './helpers/store-scroll-position';
import { shouldScrollToPreviousPosition, scrollToPreviousPosition } from './collaborators/scroll-to-previous-position';

type AutoscrollProps = {
  cid: string,
  children: ReactElement[] | ReactElement
};

const Autoscroll: FC<AutoscrollProps> = (props: AutoscrollProps): ReactElement => {
  const { cid, children } = props;
  const { enabledFeatures } = useContext(FeatureFlagsContext);
  const enableScrollReporting = enabledFeatures['cat-autoscroll-reporting'];
  const [lazyLoad, setLazyLoad] = useState(true);

  useEffect(() => {
    if (shouldScrollToPreviousPosition(cid)) {
      setLazyLoad(false);
      scrollToPreviousPosition(enableScrollReporting);
    }
  }, [cid, enableScrollReporting]);

  const childrenWithProps = React.Children.map(children, (child: React.ReactNode) => React.isValidElement(child)
    ? React.cloneElement(child, { lazyLoad })
    : null);

  return (
    <div onClick={event => storeScrollPosition(event, cid)}>
      { childrenWithProps }
    </div>
  );
};

export default Autoscroll;
